import { ROUTE_DASHBOARD_TEAM_DETAILS } from '@/constants/routes';
import { IOrganization } from '@/types/IOrganization';
import {
	ButtonGroup,
	Link as CLink,
	IconButton,
	Table,
	TableContainer,
	Tbody,
	Td,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useTeamList } from './team-list.controller';

interface ITeamProps {
	organizations: IOrganization[];
}

export default function TeamList(props: ITeamProps) {
	const { t, handleDeleteTeamClick, isLoading } = useTeamList();

	return (
		<TableContainer h="full" overflow="auto">
			<Table bg="white" borderTopRadius="md" overflow="hidden">
				<Thead>
					<Tr bg="blackAlpha.100">
						<Th>{t('Name')}</Th>
						<Th isNumeric>{t('Actions')}</Th>
					</Tr>
				</Thead>
				<Tbody>
					{props.organizations.map((organization) => {
						return (
							<Tr key={organization.id}>
								<Td>
									<CLink as={Link} to={ROUTE_DASHBOARD_TEAM_DETAILS.replace(':id', organization.id)}>
										{organization.name}
									</CLink>
								</Td>
								<Td isNumeric>
									<ButtonGroup isAttached>
										<IconButton
											isLoading={isLoading}
											onClick={() => handleDeleteTeamClick(organization.id)}
											variant="ghost"
											isRound
											icon={<FiTrash2 />}
											aria-label={t('Delete')}
										/>
										<IconButton
											isLoading={isLoading}
											as={Link}
											to={ROUTE_DASHBOARD_TEAM_DETAILS.replace(':id', organization.id)}
											variant="ghost"
											isRound
											icon={<FiEdit2 />}
											aria-label={t('Edit')}
										/>
									</ButtonGroup>
								</Td>
							</Tr>
						);
					})}
				</Tbody>
			</Table>
		</TableContainer>
	);
}
